import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import { RegistrationItemDataFragment } from '../../../data/types/api/graphql';
import { formatTestId } from '../../../data/utils/string.utils';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';
import { RegistrationListItem } from './registration-list-item';

type RegistrationListProps = {
  loading?: boolean;
  items: RegistrationItemDataFragment[];
  onClick?: (value: RegistrationItemDataFragment) => void;
};

/** registrations.content-list[.item|.empty|.loading] */
const getTestId = (suffix: string | string[] | null = null) =>
  formatTestId('content-list', 'registrations', suffix);

export function RegistrationList({
  loading = false,
  onClick,
  ...props
}: RegistrationListProps) {
  const items = useMemo(() => props.items, [props.items]);

  if (loading) {
    return (
      <p data-test-id={getTestId('loading')}>
        <CustomFormattedMessage id="common.loading" />
      </p>
    );
  }

  if (isEmpty(items)) {
    return (
      <p data-test-id={getTestId('empty')}>
        <CustomFormattedMessage id="registrations.empty" />
      </p>
    );
  }

  return (
    <div data-test-id={getTestId()} className="content-list">
      {items.map(option => (
        <div
          data-test-id={getTestId('item')}
          data-item-id={option.id}
          key={option.id}
          className="content-list__item"
        >
          <RegistrationListItem registration={option} onClick={onClick} />
        </div>
      ))}
    </div>
  );
}
